/*
 * (c) Copyright, 2019, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

interface HtmlCellProps {
  children: string
}

const HtmlCell: React.FC<HtmlCellProps> = (props) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: props.children
      }}
    />
  )
}

export default HtmlCell
